import { useMemo } from "react"
import styled from "styled-components"
import {
    Table,
    Popconfirm,
    Button,
    Switch,
    message,
    Form as AntForm,
    Select,
    Input,
    Tag
} from "antd"
import { Link } from 'react-router-dom'
import moment from 'moment'
import { useQuery } from '@apollo/client'

import { Top, Image } from '../../components'
import { useNavigateSearch, useRouteQuery, parseBoolean } from "../../utils/hooks"
import { FIND_MANY_PHILANTHROPY, FIND_MANY_PHILANTHROPY_COUNT } from '../../gqls'


const limit = 20

const Filters = styled(AntForm)`
    margin-bottom: 40px;
    margin-top: 20px;

    .item {
        width: 200px;
    }
`

const Philanthropy = () => {
    const query = useRouteQuery()
    const { page = 1, search = '', publish = true } = query
    const navigate = useNavigateSearch()

    const variables = useMemo(() => ({
        where: {
            delete: { equals: false },
            publish: typeof parseBoolean(publish) === 'boolean' ? { equals: parseBoolean(publish) } : undefined,
            OR: search ? [
                { name: { contains: search, mode: 'insensitive' } },
                { description: { contains: search, mode: 'insensitive' } },
            ] : undefined
        }
    }), [search, publish])

    const { data, loading } = useQuery(FIND_MANY_PHILANTHROPY, {
        variables: {
            ...variables,
            take: 10,
            skip: (page - 1) * limit,
            orderBy: {
                createdAt: 'desc'
            }
        },
        fetchPolicy: 'network-only'
    })
    const { data: countData, loading: countLoading } = useQuery(FIND_MANY_PHILANTHROPY_COUNT, {
        variables,
        fetchPolicy: 'network-only'
    })

    const handleChangeTable = ({ current }) => {
        // setCurrentPage(current)
        navigate(`/philanthropy`, { ...query, page: current })
    }

    const onSubmitSearch = ({ search, publish }) => {
        navigate("/philanthropy", { ...query, search, publish })
    }

    const philanthropy = useMemo(() => data ? data.findManyPhilanthropy : [], [data])
    const philanthropyCount = useMemo(() => countData ? countData.findManyPhilanthropyCount : [], [countData])

    return (
        <>
            <Top
                title={'Благотворительные организации'}
                action={
                    <Link to='add'>
                        <Button>
                            + Добавить
                        </Button>
                    </Link>
                }
            />
            <Filters
                layout='inline'
                onFinish={onSubmitSearch}
                initialValues={{
                    search,
                    publish: parseBoolean(publish)
                }}
            >
                <Filters.Item name={'search'}>
                    <Input
                        placeholder="Поиск"
                        allowClear
                        onChange={e => {
                            if (!e.target.value) {
                                navigate("/philanthropy", { ...query, search: '' })
                            }
                        }}
                        className='item'
                    />
                </Filters.Item>
                <Filters.Item name={'publish'}>
                    <Select
                        placeholder="Статус публикации"
                        // onChange={data => setBlock(data)}
                        className='item'
                        allowClear
                        onClear={() => navigate("/philanthropy", { ...query, publish: undefined })}
                    >
                        <Select.Option value={false}>
                            Не опубликованный
                        </Select.Option>
                        <Select.Option value={true}>
                            Опубликованный
                        </Select.Option>
                    </Select>
                </Filters.Item>
                <Button
                    htmlType='submit'
                    type='primary'
                >
                    Применить
                </Button>
            </Filters>
            <Table
                loading={loading || countLoading}
                rowKey={(obj) => obj.id}
                dataSource={philanthropy}
                scroll={{ x: 600 }}
                size={window.innerWidth < 500 ? 'small' : 'large'}
                pagination={{
                    current: page,
                    total: philanthropyCount,
                    pageSize: limit
                }}
                onChange={handleChangeTable}
                columns={[
                    {
                        title: 'Название',
                        dataIndex: 'name',
                        key: 'name',
                        render: (title, obj) => (
                            <Link to={obj.id}>
                                {title}
                            </Link>
                        )
                    },
                    {
                        title: 'Описание',
                        dataIndex: 'description',
                        key: 'description',
                        render: (description, obj) => (
                            <span
                                className='number-of-lines-2'
                                style={{
                                    maxWidth: 300
                                }}
                            >
                                {description}
                            </span>
                        )
                    },
                    {
                        title: 'Статус',
                        dataIndex: 'publish',
                        key: 'publish',
                        render: (publish) => (
                            <Tag color={publish ? "green" : "red"}>{publish ? "Опубликована" : "Не опубликована"}</Tag>
                        )
                    },
                    {
                        title: 'Дата создание',
                        dataIndex: 'createdAt',
                        key: 'createdAt',
                        render: (createdAt, obj) => (
                            <span>{moment(createdAt).format("DD.MM.yyyy HH:mm")}</span>
                        )
                    },
                ]}
            />
        </>
    )
}


export default Philanthropy